import { render, staticRenderFns } from "./PerformanceStrip.vue?vue&type=template&id=7b2876e7&scoped=true"
import script from "./PerformanceStrip.vue?vue&type=script&lang=js"
export * from "./PerformanceStrip.vue?vue&type=script&lang=js"
import style0 from "./PerformanceStrip.vue?vue&type=style&index=0&id=7b2876e7&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2876e7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b2876e7')) {
      api.createRecord('7b2876e7', component.options)
    } else {
      api.reload('7b2876e7', component.options)
    }
    module.hot.accept("./PerformanceStrip.vue?vue&type=template&id=7b2876e7&scoped=true", function () {
      api.rerender('7b2876e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/influencer_panel/components/PerformanceStrip.vue"
export default component.exports